// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","453":"03346f77","455":"a8863fd3","977":"240addac"}[chunkId] + ".chunk.js";
};